/**
 * The API returns uploaded-asset paths as origin-relative strings (e.g.
 * "/uploads/4/branding/…png") since it doesn't know its own public URL.
 * Used directly as an <img src>, the browser resolves that against the
 * *frontend's* origin (localhost:5173 in dev, projectpilot.infinitytech.in
 * in prod) instead of the API's — this resolves it against the API origin
 * (VITE_API_BASE_URL) instead, so it works in both environments.
 */
const API_ORIGIN = (() => {
  try {
    return new URL(import.meta.env.VITE_API_BASE_URL).origin;
  } catch {
    return '';
  }
})();

const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function resolveFileUrl(path: string | null | undefined): string | null {
  if (!path) {
    return null;
  }
  // Already absolute (http:, https:) or a local preview (blob:, data:) — leave untouched.
  if (HAS_SCHEME.test(path)) {
    return path;
  }
  return `${API_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
